import { get } from 'lodash';

/**
 * Filter objects by given properties.
 * 
 * @param {Array<Object>} array - Array with objects to be filtered.
 * @param {Array<string>} properties - Array with properties to be used as filters.
 * @param {String} keyword - Input text to be filtered.
 */
export function filterObjectsArrayByProperty(array, properties, keyword) {
    return array.filter(item => 
        properties.some(prop => 
            String(get(item, prop, '')).toLowerCase().includes(keyword.toLowerCase())
        )
    );
}
